import { businessConfig } from '../../config/business';

export default function TrustStrip() {
  const badges = [
    { icon: 'ri-shield-check-line', text: 'Licensed & Insured' },
    { icon: 'ri-home-heart-line', text: 'Residential & Commercial' },
    { icon: 'ri-calendar-check-line', text: 'Weekly Service Routes' },
    { icon: 'ri-tools-fill', text: 'Equipment Repair Experts' }
  ];

  return (
    <section className="py-8 bg-gradient-to-r from-[#f8fafc] to-[#f1f5f9] border-y border-gray-200">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {badges.map((badge, index) => (
            <div 
              key={index}
              className="flex items-center justify-center space-x-3 group"
            >
              <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center shadow-sm group-hover:shadow-md transition-shadow duration-300">
                <i className={`${badge.icon} text-xl text-[#2563eb]`}></i>
              </div>
              <span className="text-sm font-semibold text-gray-700">{badge.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
